import React from 'react'

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">
          Terms of Service
        </h1>
        <p className="text-gray-600 mb-8">
          <strong>Effective Date:</strong> February 13, 2026
        </p>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 space-y-6 text-gray-700">
          <p>
            These Terms of Service ("Terms") are entered into between TrackIEP,
            Inc. ("TrackIEP," "Company," "we," "us") and the educational
            institution or local education agency ("School," "Customer")
            accessing or using the TrackIEP platform ("Services").
          </p>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              1. Role as School Official
            </h3>
            <p className="mb-2">
              TrackIEP operates as a School Official with a legitimate
              educational interest under FERPA.
            </p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>
                Performs institutional services the School would otherwise use
                employees to perform;
              </li>
              <li>
                Is under the direct control of the School regarding education
                records;
              </li>
              <li>
                Uses Student Data solely for authorized educational purposes.
              </li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              2. Data Ownership
            </h3>
            <p>
              All Student Data remains the exclusive property of the School.
              TrackIEP acquires no ownership rights.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              3. Data Processing Addendum
            </h3>
            <p>
              The Data Processing Addendum ("DPA") is incorporated into these
              Terms and controls data protection matters.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              4. FERPA Compliance
            </h3>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Comply with FERPA;</li>
              <li>Use data only for legitimate educational interest;</li>
              <li>No unauthorized re-disclosure.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              5. HIPAA Compliance
            </h3>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Comply with HIPAA where applicable;</li>
              <li>
                Maintain administrative, technical, and physical safeguards;
              </li>
              <li>Execute a BAA upon request.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              6. No Sale or Re-Disclosure
            </h3>
            <p>
              TrackIEP shall not sell, rent, trade, or re-disclose Student Data
              without written School authorization.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              7. Direct Control
            </h3>
            <p>
              TrackIEP operates under the School's direct control and authority.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              8. Security Measures
            </h3>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Encryption in transit and at rest;</li>
              <li>Role-based access controls;</li>
              <li>Audit logging;</li>
              <li>Regular security reviews.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              9. Termination
            </h3>
            <p>
              Upon termination, Student Data will be returned or securely
              deleted at the School's direction.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              10. Governing Law
            </h3>
            <p>Governed by the laws of the State of Maryland.</p>
          </section>
        </div>
      </main>
    </div>
  )
}

export default TermsOfService
